class setHeaderBlock {
  _constructor() {
    this.$block = document.querySelector('.white-block')
  }

  _setWidth() {
    let w = 80 + '%'
    if (window.innerWidth >= 768) {
      if(window.innerWidth > 1200) {
        w = ((window.innerWidth - 1200) / 2) + (1200 * 0.75) + 'px';
      } else {
        w = window.innerWidth * 0.75 + 'px';
      }
    }
    this.$block.style.width = w
  }

  init() {
    this._constructor()
    const self = this
    let resizeTimer

    if( this.$block !== null ) {
      this._setWidth()

      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer)
        resizeTimer = setTimeout(function() {
          self._setWidth()
        }, 250)
      })
    }
  }
}
export default setHeaderBlock
